"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OS = void 0;
const u = (typeof navigator !== 'undefined' && navigator.userAgent) || '';
exports.OS = {
    Windows: u.includes('Windows'),
    Linux: u.includes('Linux'),
    Mac: u.includes('Macintosh'),
    Android: u.includes('Android') || u.includes('Adr'),
    iOS: u.includes('like Mac OS X'),
};
//# sourceMappingURL=os.js.map